import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class WithdrawalOfTheApplicationForm extends AppForm {
  constructor() {
    super({
      description: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
      localisation: new FormControl(null, [Validators.required, Validators.maxLength(5000)])
    });
  }
}
